import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RestService, ApiQueryParams } from '../lib/RestService';
import { setQueryParams } from '../lib/helpers';
import { BitrixFile } from '../lib/BitrixFile';
import { BitrixPrice } from '../lib/BitrixPrice';
import { BitrixOfferPrice } from '../lib/BitrixOfferPrice';

export class CatalogOffer {
  ID: string;
  NAME: string;
  PROPS: {
    ID: string;
    NAME: string;
    ACTIVE: 'Y' | 'N';
    PROPERTY_TYPE: string;
    CODE: string;
    VALUE: string;
    VALUE_ENUM: string;
    VALUE_XML_ID: string;
  }[];
  PRICE: BitrixOfferPrice;
}

export class CatalogItem {
  ID:	string;
  SORT:	number;
  CODE:	string;
  NAME:	string;
  XML_ID:	string;
  ACTIVE:	'Y' | 'N';
  CAN_BUY: boolean;
  BASE_PRICE: BitrixPrice;
  DATE_CREATE: Date;
  DETAIL_TEXT?: string;
  PREVIEW_TEXT:	string;
  DETAIL_TEXT_TYPE?: string;
  PREVIEW_TEXT_TYPE: string;
  DETAIL_PICTURE?: BitrixFile;
  PREVIEW_PICTURE: BitrixFile;
  IBLOCK_SECTION_ID: string;
  IBLOCK_ROOT_SECTION_ID: string;
  IBLOCK_SECTION?: {
    ID: number;
    NAME: string;
    IBLOCK_SECTION_ID: number;
  };
  PROPERTY_TAGS_VALUE?: {
      ID: string,
      XML_ID: string,
      NAME: string
  }[];
  PROPERTY_PHOTOS_VALUE?: BitrixFile[];
  PROPERTY_MORE_PHOTO_VALUE?: {
    NAME: string;
    VALUE: BitrixFile[];
  };
  PROPERTY_RECOMEND_PRODUCTS_VALUE?: {
    NAME: string;
    VALUE: string[];
  };
  PROPERTY_BRAND_VALUE?: string;
  IS_IN_COMPARE: boolean;
  PROPERTIES?: {
    NAME: string;
    VALUE: string;
  }[];
  OFFERS?: CatalogOffer[];
}

@Injectable()
export class CatalogService extends RestService {

  private apiUrl = `${environment.apiUrl}shop/Catalog/`;

  constructor(private http: HttpClient) {
    super();
  }

  public get(params?: ApiQueryParams): Promise<CatalogItem[] | any> {
    const apiUrl = setQueryParams(this.apiUrl, params);
    return this.http.get<CatalogItem[]>(apiUrl, {withCredentials: true})
      .toPromise()
      .catch(this.handleError);
  }

  // if the first argument is similar to a number then get by id
  public getByCode(code: string, params?: ApiQueryParams): Promise<CatalogItem | any> {
    const apiUrl = setQueryParams(`${this.apiUrl}${code}`, params);
    return this.http.get<CatalogItem>(apiUrl, {withCredentials: true})
      .toPromise()
      .catch(this.handleError);
  }

  public getCount(params?: ApiQueryParams): Promise<{count: number} | any> {
    const apiUrl = setQueryParams(`${this.apiUrl}count`, params);
    return this.http.get<{count: number}>(apiUrl, {withCredentials: true})
      .toPromise()
      .catch(this.handleError);
  }
}
